import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {Selecter, SelecterConfig} from "./selecter";

export const selecterLoader = function (options = {}) {
    componentLoader(componentConfig(Selecter, SelecterConfig.componentTypeKey, SelecterConfig.baseHtmlClass), options);
};
